export const usersSearchOptions = [
  { value: 'email', label: 'Email' },
  { value: 'name', label: 'Name' },
]
